import {Component, EventEmitter, Output} from '@angular/core';
@Component({
    selector: 'app-endcustomer-need-pascom-approval',
    templateUrl: './endcustomer-need-pascom-approval.component.html',
    standalone: false
})
export class EndcustomerNeedPascomApprovalComponent {
  @Output() next = new EventEmitter();
}
